import { render, staticRenderFns } from "./sample-account-icon-profile-wh40.vue?vue&type=template&id=835f2c0a&"
import script from "./sample-account-icon-profile-wh40.vue?vue&type=script&lang=js&"
export * from "./sample-account-icon-profile-wh40.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports